import { SERVICE } from './constants'

export const FETCH_INVITATIONS = `${SERVICE}/FETCH_INVITATIONS`
export const SET_FETCH_INVITATIONS_ERROR = `${SERVICE}/SET_FETCH_INVITATIONS_ERROR`
export const SET_INVITATIONS = `${SERVICE}/SET_INVITATIONS`
export const SET_PAGINATION = `${SERVICE}/SET_PAGINATION`
export const UPDATE_INVITATION = `${SERVICE}/UPDATE_INVITATION`

export const SET_SELECTED = `${SERVICE}/SET_SELECTED`
export const SELECT_INVITATION = `${SERVICE}/SELECT_INVITATION`
export const RESET_SELECTED = `${SERVICE}/RESET_SELECTED`
export const RESET_SELECTED_ON_PAGE = `${SERVICE}/RESET_SELECTED_ON_PAGE`
export const SELECT_ALL = `${SERVICE}/SELECT_ALL`

export const GET_SEARCH_OPTIONS = `${SERVICE}/GET_SEARCH_OPTIONS`
export const SET_SEARCH_OPTIONS = `${SERVICE}/SET_SEARCH_OPTIONS`
export const CLEAR_SEARCH_OPTIONS = `${SERVICE}/CLEAR_SEARCH_OPTIONS`

export const REMOVE = `${SERVICE}/REMOVE`
export const REMOVE_ERROR = `${SERVICE}/REMOVE_ERROR`
export const REMOVE_SUCCESS = `${SERVICE}/REMOVE_SUCCESS`
export const REMOVE_FAKE = `${SERVICE}/REMOVE_FAKE`

export const SET_SEARCH_FILTERS = `${SERVICE}/SET_SEARCH_FILTERS`
export const RESET_SEARCH_FILTERS = `${SERVICE}/RESET_SEARCH_FILTERS`

export const RESEND_INVITATION = `${SERVICE}/RESEND_INVITATION`
export const RESEND_INVITATION_CLEAR = `${SERVICE}/RESEND_INVITATION_CLEAR`
export const RESEND_INVITATION_CONFIRM = `${SERVICE}/RESEND_INVITATION_CONFIRM`
export const RESEND_INVITATION_SUCCESS = `${SERVICE}/RESEND_INVITATION_SUCCESS`
export const CONFIRM_RESEND_INVITATION = `${SERVICE}/CONFIRM_RESEND_INVITATION`
